import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

import Home from '@/view/home/index'
import Info from '@/view/info/index'
import Join from '@/view/join/index'

export const constantRouterMap = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
            title: '首页'
        }
    },
    {
        path: '/info',
        name: 'Info',
        component: Info,
        meta: {
            title: '关于我们'
        }
    },
	{
	    path: '/join',
	    name: 'Join',
	    component: Join,
	    meta: {
	        title: '司机加入'
	    }
	}
]
export default new Router({
    routes: constantRouterMap,
    mode: "history"
})